"use client";

import { ThemeToggle } from "@/components/ui/ThemeToggle";
import { cn } from "@/lib/utils";
import { NavigationBarProps } from "@/types/props/ui/NavigationBar.type";
import { useRouter } from "next/navigation";
import { useState } from "react";

function NavigationBar({ title, links, hrefLogo }: NavigationBarProps) {
  const [isBurgerOpen, setIsBurgerOpen] = useState(false);
  const handleClickBurger = () => {
    setIsBurgerOpen(!isBurgerOpen);
  };
  const router = useRouter();
  const handleClickLogo = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!hrefLogo) {
      e.preventDefault();
      return;
    }

    router.push(hrefLogo);
  };

  return (
    <nav className="grid grid-cols-4 gap-1 mc-panel border-x-0 border-t-0 py-2.5 px-5 sticky top-0 z-10">
      {title ? (
        <div
          className="col-span-1 place-items-center-safe cursor-pointer font-bold pixelated"
          onClick={handleClickLogo}
        >
          {title}
        </div>
      ) : null}
      <ul className="col-span-2 sm:flex justify-center items-center hidden gap-2 list-none m-0 p-0">
        {links?.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              className="mc-btn inline-block px-3 py-1.5 text-base uppercase tracking-wide hover:text-white transition-colors"
            >
              {link.name}
            </a>
          </li>
        ))}
      </ul>
      {isBurgerOpen && (
        <ul
          className={cn(
            "absolute w-full animate-slideDown mt-1.5 left-0 mc-panel top-full p-2 px-5 space-y-2 sm:hidden list-none"
          )}
        >
          {links?.map((link) => (
            <li key={link.href}>
              <a href={link.href} className="mc-btn inline-block w-full px-3 py-2 text-center uppercase tracking-wide">
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      )}
      <div
        className="absolute right-10 p-2 top-1/3 sm:hidden mc-slot cursor-pointer"
        onClick={handleClickBurger}
        aria-label="Toggle menu"
      >
        <div className="border-b-4 border-foreground w-6"></div>
        <div className="border-b-4 border-foreground w-6 mt-1"></div>
        <div className="border-b-4 border-foreground w-6 mt-1"></div>
      </div>
      <div className="col-span-1 sm:flex justify-end hidden items-center">
        <ThemeToggle />
      </div>
    </nav>
  );
}

export default NavigationBar;
